module.exports = __webpack_public_path__ + "img/robot-swiper-img4.bf1459b2.png";